var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 1c1.893 0 3.61.751 4.87 1.971l-.733.683a6 6 0 101.606 2.605l.802-.748A7 7 0 118 1zm6.862 2.147c.174.176.183.45.03.636l-.042.045L7.263 11 4.116 7.348a.475.475 0 01.058-.679.498.498 0 01.649.014l.043.043 2.469 2.866 6.833-6.457a.497.497 0 01.694.012z"
  }))));
}

export default __webpack_public_path__ + "ab8207e877b8a9712e698542630ce7ee.svg";
export { SvgIconCheckLight as ReactComponent };